import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-instant-digital-business-cards',
  templateUrl: './instant-digital-business-cards.component.html',
  styleUrls: ['./instant-digital-business-cards.component.scss', './instant-digital-business-cards-media.component.scss']
})
export class InstantDigitalBusinessCardsComponent {

  currentLang: string = '';

  constructor(public translate: TranslateService) {
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
